import React, { ReactNode, useContext, useMemo } from 'react';

import { Socket } from 'socket.io-client';
import { getToken } from 'src/state';
import { ioFactory } from './common';

type SocketContextType = {
  io: Socket;
};

const SocketContext = React.createContext<SocketContextType | null>(null);

export function useSocketIO(): SocketContextType {
  const ctx = useContext(SocketContext);

  if (!ctx) {
    throw new Error("can't use useSocketIO outside of an SocketProvider");
  }
  return ctx;
}

export function SocketProvider({
  children,
  namespace = '',
}: {
  children: ReactNode;
  namespace?: string;
}): JSX.Element {
  const token = getToken();

  const clientRef = useMemo<Socket>(
    () =>
      ioFactory({
        authorization: token as string,
        namespace,
      }),
    [token, namespace],
  );

  const memoizedValue = useMemo(
    () => ({
      io: clientRef,
    }),
    [clientRef],
  );

  return (
    <SocketContext.Provider value={memoizedValue}>
      {children}
    </SocketContext.Provider>
  );
}
